import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import styled from 'styled-components';
import { map, chunk, round, isEmpty } from 'lodash';
import PartySectionItems from './PartySectionItems';

const InnerRowWrapper = styled(Row)`
  margin-top: 35px;
  &:first-child {
    margin-top: 0;
  }
`;

const PartySection = ({ dataSource = [], gridMinColumn = 4 }) => {
  if (isEmpty(dataSource)) return null;
  const colSpan = round(24 / gridMinColumn);
  let rowCount = dataSource.length / gridMinColumn;
  rowCount = dataSource.length % gridMinColumn > 0 ? rowCount + 1 : rowCount;
  const result = rowCount > 1 ? chunk(dataSource, gridMinColumn) : dataSource;
  return (
    <>
      {rowCount > 1 ? (
        map(result, (items, indx) => (
          <InnerRowWrapper key={`parth_section_${indx}`}>
            {map(items, (item, idx) => (
              <PartySectionItems
                source={item}
                colSpan={colSpan}
                showDivider={idx < items.length - 1}
                key={`parth_section_items_${idx}`}
              />
            ))}
          </InnerRowWrapper>
        ))
      ) : (
        <Row>
          {map(result, (item, idx) => (
            <PartySectionItems
              source={item}
              colSpan={colSpan}
              showDivider={idx < result.length - 1}
              key={`parth_section_items_${idx}`}
            />
          ))}
        </Row>
      )}
    </>
  );
};

PartySection.prototype = {
  dataSource: PropTypes.array,
  gridMinColumn: PropTypes.number
};

export default PartySection;
